import React from 'react';
import { Spinner } from 'reactstrap';

const CustomLoader = ({
    text = 'Loading...',
    spinnerSize = 80,
    spinnerBorderWidth = 4,
    spinnerClassName = 'loader-30',
    overlayColor = 'rgba(62, 62, 62, 0.5)',
    textColor = '#fff',
    zIndex = 9999
}) => {
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: overlayColor,
                zIndex: zIndex
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
            >
                <div className="loader-box">
                    <Spinner
                        attrSpinner={{
                            className: spinnerClassName,
                            style: {
                                width: `${spinnerSize}px`,
                                height: `${spinnerSize}px`,
                                border: `${spinnerBorderWidth}px solid rgb(255, 255, 255)`,
                                borderTop: `${spinnerBorderWidth}px solid #fff`
                            }
                        }}
                    />
                </div>
                <h5
                    style={{
                        color: textColor,
                        textAlign: 'center'
                    }}
                >
                    {text}
                </h5>
            </div>
        </div>
    );
};

export default CustomLoader;